import React from "react";
import { device, theme } from "../../../utils";
import styled from "styled-components";
import ContentAbout from "./about";
import Contact from "./contact";
import LuxWeb3Context from "../../../context/LuxWeb3Context";

const ContentContactWrap = styled.div`
  position: relative;

  #info-content {
    padding-top: 10px;

    @media ${device.md} {
      padding-top: 20px;
    }



    // HEADER
    .content-header {
      margin-bottom: 10px;
      font-size: 18px;
      @media (max-width: 767px) { font-size: 16px; }
      text-shadow: 0 0 0 #000;
      cursor: pointer;
      text-align: center;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      max-width: 400px;
      width: 95%;

      @media ${device.sm} {
        font-size: 22px;
        @media (max-width: 767px) { font-size: 20px; }
      }

      @media ${device.md} {
        font-size: 25px;
        margin-bottom: 10px;
      }

      &.cult-button {
        margin-bottom: 15px;
      }
    }

    .text-subheader {
      font-size: 16px;
      @media (max-width: 767px) { font-size: 14px; }
      text-shadow: 0 0 1px #000;
      margin: 10px 0;
      line-height: 18px;

      @media ${device.md} {
        font-size: 25px;
        line-height: 22px;
        margin-top: 15px;
      }
    }


    // BODY CONTENT
    .body-wrap {
      height: 0;
      overflow: hidden;

      &.open {
        height: 100%;
        overflow: visible;
      }
    }

    .content-body {
      font-size: 14px;
      @media (max-width: 767px) { font-size: 12px; }
      padding: 0 5px;
      text-align: center;
      
      @media ${device.lg} {
        font-size: 18px;
        padding: 0 90px;
      }

      &.content-entry {
        @media ${device.md} {
          font-size: 20px;
        }
      }

      .content-image {
        width: 100%;
      }

      &.image-wrap img {
        max-width: 850px;
      }

      .exchange-image-wrap {
        position: relative;
        margin-bottom: 40px !important;

        .text-subheader.nft-text,
        .text-subheader.claimed-neon-text {
          position: absolute;
          bottom: -40px;
        }
        .text-subheader.nft-text {
          left: 10px;

          @media ${device.md} {
            left: 87px;
          }
        }
        .text-subheader.claimed-neon-text {
          right: 10px;
          
          @media ${device.md} {
            right: 87px;
          }
        }
      }
      

      .text-bold {
        text-shadow: 0px 0px 1px #000;
        color: ${theme.cultPalette[1] === '#950AFF' ? '#cecece':'inherit'};
      }
    }
  
    // UTIL
    .text-center {
      text-align: center;
    }
  }
`;

class ContentContact extends React.Component {
  constructor(props) {
    super(props);
  }
  static contextType = LuxWeb3Context;


  render() {
    return (
      <ContentContactWrap>
        <ul id="info-content" ref="">
          <ContentAbout noNftsFound={this.props.noNftsFound}/>
          <br/>
          <Contact />
        </ul>
      </ContentContactWrap>
    );
  }
};

export default ContentContact;